import React from 'react';
import $ from 'jquery';

const Popup = props => {
    const { permalink, title, detailImg1, detailImg2, previewTxt, sourceTxt, sourceURL, description } = props.workData;

    $(document).ready(() => {
        $(`a.workItem[href$='#popup-${permalink}']`).click(() => {
            $(`#popup-${permalink} .popupContent .popupLeft`).prepend(`<img src=${detailImg1} alt=${title} class="popupImg" />`);
            $(`#popup-${permalink} .popupContent .popupLeft`).append(`<img src=${detailImg2} alt=${title} class="popupImg" />`);
        });

        $(`#popup-${permalink} .popupContent .popupClose`).click(() => $(`#popup-${permalink} .popupContent .popupLeft .popupImg`).remove());
    });

    return (
        <div className="popup" id={"popup-" + permalink}>
            <div className="popupContent">
                <div className="popupLeft"></div>

                <div className="popupRight">
                    <a href="#work" className="popupClose">&times;</a>

                    <h2 className="headingSecondary mbSmall">{title}</h2>
                    {description}

                    {previewTxt && <a href={"#preview-" + permalink} className="btn btn-primary mrBig">{previewTxt}</a>}
                    {sourceTxt && <a href={sourceURL} target="_blank" rel="noreferrer noopener" className="btn btn-primary">{sourceTxt}</a>}
                </div> {/* Popup Right */}
            </div> {/* Popup Content */}
        </div> // Popup
    );
};

export default Popup;